
<button (click)="iot.addMissingConfigDefaultsToAllThings()">MASS CONFIG - FAFO</button>
